import { getSocialInsuranceDailyBase } from '../LegalParameters/SocialInsuranceDailyBase';
import {
	SOCIAL_INSURANCE_REDUCTION_MULTIPLIERS_CHILDCARE,
	PPM_DURATION,
} from '../LegalParameters/Constants';

const round = number => {
	return Math.round(number * 100) / 100;
};

export default ({ monthlyInsurance, children, year }) => {
	const dvzNonReduced = ((monthlyInsurance / 0.023) * 12) / 365;
	const duration = PPM_DURATION[children === 1 ? 'ONE_CHILD' : 'MORE_CHILDREN'];

	const dailyBase = getSocialInsuranceDailyBase({
		income: dvzNonReduced,
		year,
		multipliers: SOCIAL_INSURANCE_REDUCTION_MULTIPLIERS_CHILDCARE[year],
		full: true,
	});

	const dvzReduced = dailyBase.reduce((acc, value) => acc + value, 0);
	const dvzDay = Math.ceil(0.7 * dvzReduced);

	return {
		dvzReduced: Math.ceil(dvzReduced),
		dvzNonReduced: round(dvzNonReduced),
		dvzDay,
		dvzResult: {
			day: dvzDay,
			month: dvzDay * 30,
			total: dvzDay * duration,
		},
		reduction: dailyBase.map(round),
		duration,
	};
};
